import React , { Component, Fragment } from 'react'
import { Table , Input , Button , Icon } from 'antd'
import Axios from 'axios'
import keys from '../../keys'
import Highlighter from 'react-highlight-words';

class AttendanceTable extends Component{

    state = {
        loading:false,
        attendances:[],
        error : "",
        searchText: '',
        searchedColumn: '',
    }

    //search feature
    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={node => {
                this.searchInput = node;
              }}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Button
              type="primary"
              onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              icon="search"
              size="small"
              style={{ width: 90, marginRight: 8 }}
            >
              Search
            </Button>
            <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
          </div>
        ),
        filterIcon: filtered => (
          <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
          record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select());
          }
        },
        render: text =>
          this.state.searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text.toString()}
            />
          ) : (
            text
          ),
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
      };

    ///




    componentDidMount(){
        this.setState({loading:true})
        Axios.get(`${keys.server}/hr/list-attendance/`)
        .then(
            (result) => {
                console.log(result)
                this.setState(
                    {   
                        loading:false,
                        attendances:result.data
                    }
                )
            }
        )
        .catch(
            err =>{
                this.setState({
                    loading:false,
                    error : err
                })
            }
        )
    }

    columns = [
        {
            key:"date",
            dataIndex:"date",
            title:"Date",
            ...this.getColumnSearchProps('date'),
        },

        {
            key: "nic",
            dataIndex: "NIC",
            title: "NIC",
            ...this.getColumnSearchProps('NIC'),

        } ,
        {
          key: "name",
          dataIndex: "name",
          title: "Name",
          ...this.getColumnSearchProps('name'),

      } ,
        

        {
            key:"type",
            dataIndex:"attendance_type",
            title:"CHECKIN/CHECKOUT",
            ...this.getColumnSearchProps('attendance_type'),
        },
        {
            key:"time",
            dataIndex:"time",
            title:"Time"
        },

    ]

    formatTableData = (data) => {
        return data.map(
            (att) => {
                return {
                    key:att.id,
                    date:att.time.substr(0,10),
                    NIC : att.employee.NIC,
                    name : att.employee.full_name,
                    attendance_type:att.attendance_type,
                    time: att.time.substr(11,5)
                }
            }
        )
    }



    render(){
        return( 
        <Fragment>
            <Table loading={this.props.loading} columns={this.columns} dataSource={this.formatTableData(this.state.attendances)} />       
        </Fragment>
        )
    }

}

export default AttendanceTable